export default __webpack_public_path__ + "static/media/avatar_153.0ea4ca6e.png";